import React from 'react'
import PropTypes from 'prop-types'
import EmailTemplateVariant from './EmailTemplateVariant'


const EmailTemplateVariantList = ({ emailTemplateVariantList, isEmailAdmin, changeEmailTemplateVariant, saveEmailTemplateVariant, testEmailTemplateVariant, deleteEmailTemplateVariant }) => {
    return (
        <div>
            {emailTemplateVariantList.map(emailTemplateVariant => {
                return (
                    <EmailTemplateVariant
                        key={emailTemplateVariant.localId}
                        isEmailAdmin={isEmailAdmin}
                        emailTemplateVariant={emailTemplateVariant}
                        changeEmailTemplateVariant={changeEmailTemplateVariant}
                        saveEmailTemplateVariant={saveEmailTemplateVariant}
                        testEmailTemplateVariant={testEmailTemplateVariant}
                        deleteEmailTemplateVariant={deleteEmailTemplateVariant}
                    />)
            })}
        </div>
    )
}


EmailTemplateVariantList.propTypes = {
    emailTemplateVariantList: PropTypes.array.isRequired,
    isEmailAdmin: PropTypes.bool.isRequired,

    changeEmailTemplateVariant: PropTypes.func.isRequired,
    saveEmailTemplateVariant: PropTypes.func.isRequired,
    testEmailTemplateVariant: PropTypes.func.isRequired,
    deleteEmailTemplateVariant: PropTypes.func.isRequired,
}


export default EmailTemplateVariantList




// WEBPACK FOOTER //
// ./src/modules/email/component/manage/EmailTemplateVariantList.js